<template>
	<thead>
		<tr>
			<th style="width:30%">
				Patient
			</th>
			<th style="width:70%">
				Events
			</th>
		</tr>
	</thead>
</template>
<script>
export default {
	name: 'add-schedule-row-head',
	props: ['type']
}
</script>
<style lang="scss" scoped>
@import "style.scss";
</style>
